/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getOwner = /* GraphQL */ `
  query GetOwner($id: ID!) {
    getOwner(id: $id) {
      id
      email
      name
      homes {
        items {
          id
          address
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ownerHomesId
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listOwners = /* GraphQL */ `
  query ListOwners(
    $filter: ModelOwnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOwners(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        name
        homes {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncOwners = /* GraphQL */ `
  query SyncOwners(
    $filter: ModelOwnerFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncOwners(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        email
        name
        homes {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getHome = /* GraphQL */ `
  query GetHome($id: ID!) {
    getHome(id: $id) {
      id
      address
      owner {
        id
        email
        name
        homes {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      IntentResponses {
        items {
          id
          intent
          response
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          homeIntentResponsesId
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      ownerHomesId
    }
  }
`;
export const listHomes = /* GraphQL */ `
  query ListHomes(
    $filter: ModelHomeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHomes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        address
        owner {
          id
          email
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        IntentResponses {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        ownerHomesId
      }
      nextToken
      startedAt
    }
  }
`;
export const syncHomes = /* GraphQL */ `
  query SyncHomes(
    $filter: ModelHomeFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncHomes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        address
        owner {
          id
          email
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        IntentResponses {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        ownerHomesId
      }
      nextToken
      startedAt
    }
  }
`;
export const getIntentResponse = /* GraphQL */ `
  query GetIntentResponse($id: ID!) {
    getIntentResponse(id: $id) {
      id
      home {
        id
        address
        owner {
          id
          email
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        IntentResponses {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        ownerHomesId
      }
      intent
      response
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      homeIntentResponsesId
    }
  }
`;
export const listIntentResponses = /* GraphQL */ `
  query ListIntentResponses(
    $filter: ModelIntentResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntentResponses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        home {
          id
          address
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ownerHomesId
        }
        intent
        response
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        homeIntentResponsesId
      }
      nextToken
      startedAt
    }
  }
`;
export const syncIntentResponses = /* GraphQL */ `
  query SyncIntentResponses(
    $filter: ModelIntentResponseFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncIntentResponses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        home {
          id
          address
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          ownerHomesId
        }
        intent
        response
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        homeIntentResponsesId
      }
      nextToken
      startedAt
    }
  }
`;
